import { css } from '@emotion/react';
import ClickableContainer from 'components/clickable-container';
import ProfilePicture from 'org_level_profile/components/profile-picture';
import { User } from 'redux/schemas/models/my-account';
import { halfSpacing, largeSpacing, threeQuartersSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';

type NvSubmissionCardProps = {
  title: string;
  description: string;
  status?: JSX.Element;
  headerBackgroundColor: string;
  headerBorderColor: string;
  user: User;
  onClick?: () => void;
};

const styles = css`
  width: 300px;
  height: 260px;
  justify-content: flex-end;
  position: relative;
  .avatar {
    position: absolute;
    left: 50%;
    /* content-container is at the bottom and is 230px tall, so its top edge
       sits 30px from the top of the outer container. Translate so the avatar
       is centered horizontally and vertically straddles that edge. */
    top: ${largeSpacing}px;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .content-container {
    position: relative;
    height: 230px;
    border-radius: ${threeQuartersSpacing}px;
    box-shadow: 0px 4px ${halfSpacing}px 0px rgba(0, 0, 0, 0.1);
    .header-section {
      padding-top: 35px;
      border-top-width: 3px;
      border-top-style: solid;
      border-top-left-radius: ${threeQuartersSpacing}px;
      border-top-right-radius: ${threeQuartersSpacing}px;
      .title {
        min-width: 0;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .body-section {
      border-bottom-left-radius: ${threeQuartersSpacing}px;
      border-bottom-right-radius: ${threeQuartersSpacing}px;
    }
    .description {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

const NvSubmissionFeedbackCard = (props: NvSubmissionCardProps) => {
  const { title, description, status, headerBackgroundColor, headerBorderColor, user, onClick } = props;

  return (
    <div css={styles}>
      <ClickableContainer
        className='outer-container bg-transparent d-flex flex-column h-100 justify-content-end'
        onClick={onClick}
      >
        <div className='avatar'>
          <ProfilePicture
            profile={user}
            isRound
            size={tripleSpacing}
            borderColor={headerBorderColor}
          />
        </div>
        <div className='content-container d-flex flex-column w-100'>
          <div
            className='header-section d-flex align-items-center justify-content-center pb-3 px-4'
            style={{ backgroundColor: headerBackgroundColor, borderTopColor: headerBorderColor }}
          >
            <p className='mb-0 font-weight-bold title'>{title}</p>
          </div>
          <div className='body-section px-5 pt-4 pb-5 d-flex flex-column justify-content-between'>
            {status && <div className='d-flex align-items-center mb-2'>{status}</div>}
            <p className='mb-0 description font-weight-normal italic'>{description}</p>
          </div>
        </div>
      </ClickableContainer>
    </div>
  );
};

export default NvSubmissionFeedbackCard;
